import type adminAPI from "@/services/api";

export type SaveAgentFeedbackAdditionalLossPayload = Parameters<
  typeof adminAPI.saveAgentFeedbackAdditionalLoss
>[1];

/** Port of components/agent-feedback/DefaultAdditionalLossForm.ts (Vue) — Dinero replaced by its JSON shape. */
const booleanOptions = [
  { value: true, label: "Oui" },
  { value: false, label: "Non" },
];

export const invoiceOptions = [
  { value: "TRAVEL_AGENCY_LOSS", label: "Perte agence" },
  { value: "ENTERPRISE_ACCOUNT", label: "Facturé sur le compte de l'entreprise" },
];

export const nextFlightOptions = [
  { value: "UNKNOWN", label: "Je ne sais pas" },
  { value: "SAME_DAY", label: "Nouveau vol le jour même" },
  { value: "NEXT_DAY_OR_LATER", label: "Nouveau vol le lendemain ou plus tard" },
  { value: "NO_NEXT_FLIGHT", label: "Pas eu de nouveau vol" },
];

export const accommodationDutyOptions = [
  { value: "ADDITIONAL_ACCOMMODATION", label: "Le passager a dormi a l'hotel" },
  { value: "PASSENGERS_SLEPT_AT_AIRPORT", label: "Le passager a dormi a l’aéroport" },
  { value: "OTHER_NO_COSTS", label: "Le passager s’est débrouillé et n’a rien déboursé" },
  { value: "UNKNOWN", label: "Je ne sais pas" },
];

export const causesOptions = [
  { value: "WEATHER", label: "Météo" },
  { value: "TECHNICAL_INCIDENT", label: "Incident technique" },
  { value: "AIRPORT_ISSUES", label: "Problèmes à l'aéroport" },
  { value: "STRIKE", label: "Grève" },
  { value: "UNKNOWN", label: "Je ne sais pas" },
  { value: "OTHER", label: "Autre (merci d'indiquer dans la note)" },
];

const defaultPrice = { amount: 0, currency: "EUR", precision: 2 as const };

/** Same payload the Vue form sends (Dinero serializes to { amount, currency, precision }). */
export function buildAdditionalLossPayload(note?: string): SaveAgentFeedbackAdditionalLossPayload {
  return {
    rerouting: {
      reRoutedAtAirlineExpense: booleanOptions[1],
      newTicket: {
        price: defaultPrice,
        paidBy: invoiceOptions[1],
      },
      nextFlightOption: nextFlightOptions[0],
    },
    accommodationDutyOption: accommodationDutyOptions[3],
    additionalAccommodation: {
      price: defaultPrice,
      paidBy: invoiceOptions[1],
    },
    additionalExpenses: {
      price: defaultPrice,
      paidBy: invoiceOptions[1],
    },
    lostAccommodation: {
      price: defaultPrice,
      paidBy: invoiceOptions[1],
    },
    totalOtherLoss: {
      price: defaultPrice,
      paidBy: invoiceOptions[1],
    },
    cause: causesOptions[4],
    ...(note ? { note } : {}),
  };
}
